export default "__VITE_ASSET__B2BVySZ3__"